import * as React from "react";
import GlobalStyles from "@mui/material/GlobalStyles/GlobalStyles";
import Container from "@mui/material/Container/Container";
import Grid from "@mui/material/Grid/Grid";
import Button from "@mui/material/Button/Button";
import Stack from "@mui/material/Stack/Stack";
import CircularProgress from "@mui/material/CircularProgress/CircularProgress";
import ProjectListItem from "../../components/project-list-item";
import ProjectGridItem from "../../components/project-grid-item";
import moment from 'moment';
import firebase from "../../firebase/firebase";
import Dialog from "@mui/material/Dialog/Dialog";
import DialogTitle from "@mui/material/DialogTitle/DialogTitle";
import Typography from "@mui/material/Typography/Typography";
import IconButton from "@mui/material/IconButton/IconButton";
import CloseIcon from '@mui/icons-material/Close';
import DialogContent from "@mui/material/DialogContent/DialogContent";
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import DialogContentText from "@mui/material/DialogContentText/DialogContentText";
import DialogActions from "@mui/material/DialogActions/DialogActions";
import {useNavigate } from 'react-router-dom'
import {AuthUserContext} from "../../providers/AuthProvider";
import SearchIcon from '@mui/icons-material/Search';
import GridViewSharpIcon from "@mui/icons-material/GridViewSharp";
import ReorderSharpIcon from "@mui/icons-material/ReorderSharp";
import ArtistGridItem from "../../components/artist-grid-item";
import ArtistListItemNew from "../../components/ArtistListItem";
import ScrollToTop from "../../utils/scrollTop";

const Skills = [
  "All Skills",
  "blender",
  "maya",
  "photoshop",
  "unity 3D"
]
const filterStyleDiv = {
  background : "#E3E8F0" ,
  border: "1px solid #E3E8F0",
  borderRadius: "50px",
  outline : "none",
  color : "#204488",
  alignItems : "center",
  padding: "0px 12px"
}

const filterStyleSelect = {
  background : "#E3E8F0" ,
  border: "1px solid #E3E8F0",
  borderRadius: "50px",
  fontSize : "16px",
  outline : "none",
  color : "#204488"
}

function ArtistsList() {
  const navigator = useNavigate();
  const [searchArtist , setSearchArtist] = React.useState('')
  const [artistView, setArtistView] = React.useState('Grid')
  const [services, setServices] = React.useState([])
  const [filterData, setFilterData] = React.useState([])
  const [ skill , setSkill] =React.useState('All Skills')

  const selectSkill = (event) => {
    setSkill(event.target.value)
  }

  const search = () => {
     
    if (searchArtist === '') {
      setFilterData([...services])
    } else {
      const regex = new RegExp(searchArtist);
      setFilterData(services.filter((u) => regex?.test(u.title) || regex?.test(u.creatorName) ));
    }
  }
  React.useEffect(() => {
    const serviceRef = firebase.firestore().collection('services').orderBy('createdAt', "desc")
    serviceRef.get()
      .then((snapshot) => {
        if (snapshot.size > 0){
          const list = []
          snapshot.docs.forEach((d) => {
            list.push({id: d.id, ...d.data()});
          })

          setServices(list);
        }
      })
  }, [])
  const filteredArtist = services.filter((item) => {return (searchArtist === "" ? true : (item.name.toLowerCase()).startsWith(searchArtist.toLowerCase())) && (skill === "All Skills" ? true : ( item.skills.includes(skill)))})
  return (
    <React.Fragment>
      <ScrollToTop/>
      <GlobalStyles styles={{ ul: { margin: 0, padding: 0, listStyle: 'none' } }} />


     <Container maxWidth="lg" sx={{textAlign: 'left', pb:5, mt: 5}}>
      <Stack direction={'row'} spacing={5} justifyContent="start"
               alignItems="start">
       <Typography variant={'h3'} color={'primary'} sx={{mb:5,mt:-1}}>
         Artists
       </Typography>
       <div style={{flex: 1}}/>
       <div style={{ display : "flex", flexDirection : "row" , justifyContent : "space-between"}}>


       <Stack direction='row'  justifyContent="center"
                   alignItems="center">
              <TextField value={searchArtist} 
               onChange={(e) => setSearchArtist(e.target.value)}
               onKeyDown={(e) => {
                  if (e.code === "Enter") {
                    search()
                  }
                }}
                 sx={{width:'90%', textAlign:'left', outline:'none'}} size={"small"}/>
              <Button variant={'contained'} sx={{ borderRadius: 0, boxShadow:'none', py: 1.15}} size={"small"} onClick={search}><SearchIcon/></Button>
            </Stack>
            {/* <Autocomplete spacing={2} sx={{ width: 300, mt: -10}}
              freeSolo
              id="free-solo-2-demo"
              disableClearable
              options={ ["all" , ...services.map((option) => option.name)]}
              value = {searchArtist}
              onChange={(e , newValue) => { setSearchArtist(newValue)}}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label=  {<SearchIcon />}
                  InputProps={{
                    ...params.InputProps,
                    type: 'search',
                  }}/>
                  )}

              /> */}
              {/* <small>View:</small> */}
              {''}
              <IconButton size={'small'} color={'primary'} sx={{ 
                opacity: artistView === 'Grid'? 1 : .5, 
              }} onClick={() => setArtistView('Grid')}>
                <GridViewSharpIcon />
              </IconButton>
              {/* | */}
              <IconButton size={'small'} color={'primary'}  sx={{ 
                opacity: artistView == 'List'? 1 : .5
              }} onClick={() => setArtistView('List')}>
                <ReorderSharpIcon />
              </IconButton>
              {''}
            </div>
            </Stack>

            <Stack direction={"row"} spacing={5}  justifyContent="flex-start"
                          alignItems="center" mb={3}>
                          <div style={filterStyleDiv}>
                          <select value={skill} onChange={selectSkill} style={filterStyleSelect} >
                              {Skills.map((t) => (
                                  <option value={t}>{t}</option>
                              ))}
                          </select>
                          </div>
            </Stack>

            <Grid container spacing={3} alignItems="start" sx={{mb:5}}>
          {services.length > 0 && filteredArtist.map((service) => {
            return artistView === 'Grid'  ?
            <ArtistGridItem
              title={service.name}
              posted={moment(service.createdAt.seconds * 1000).format('MMM DD, YYYY | HH:mm')}
              location={service.location}
              genre={service.skills}
              image={service.avatar}
              id={service.id}
            /> : <ArtistListItemNew
              title={service.name}
              posted={moment(service.createdAt.seconds * 1000).format('MMM DD, YYYY | HH:mm')}
              location={service.location}
              genre={service.skills}
              image={service.avatar}
              id={service.id}/>
          })
          }

        </Grid>
      </Container>


    </React.Fragment>
  )
}
export default ArtistsList;